<script lang="ts" setup>
interface TickerItem {
  rank: number
  name: string
  imageUrl?: string | null
}

const props = withDefaults(defineProps<{
  items: TickerItem[]
  label?: string
  shortLabel?: string
  loading?: boolean
}>(), {
  label: 'Top Market Maker Rankings (30D)',
  shortLabel: 'Top Rankings (30D)',
  loading: false,
})

const MM_LOGO_BASE = '/images/market-maker-logos/'
const MM_LOGO_FALLBACK = `${MM_LOGO_BASE}other.png`

function resolveLogoSrc(path?: string | null) {
  if (!path) {
    return undefined
  }
  if (path.startsWith('http') || path.startsWith('/')) {
    return path
  }
  return MM_LOGO_BASE + path
}

const tickerItems = computed(() => props.items.map(item => ({
  ...item,
  logoSrc: resolveLogoSrc(item.imageUrl),
})))
</script>

<template>
  <PrTickerBar
    :items="tickerItems"
    :label="label"
    :short-label="shortLabel"
    :logo-fallback="MM_LOGO_FALLBACK"
    :loading="loading"
  >
    <template #value="{ item }">
      <span class="font-mono text-xs tracking-[-0.2px] whitespace-nowrap text-placeholder">
        #{{ item.rank }}
      </span>
    </template>
  </PrTickerBar>
</template>
